import React, { useEffect, useRef } from 'react';
import {
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Divider,
  Typography
} from '@mui/joy';

/**
 * Modal for displaying text crop preview on canvas
 */
const TextCropModal = ({
  open,
  onClose,
  cropBox,
  imageUrl
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!open || !cropBox || !imageUrl) return;

    // Delay slightly to allow DOM to mount
    const timeout = setTimeout(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;

      const { x0, y0, x1, y1 } = cropBox;
      const width = x1 - x0;
      const height = y1 - y0;

      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(
          img,
          x0, y0, width, height, // source rectangle
          0, 0, width, height    // destination rectangle
        );
      };

      img.onerror = (e) => {
        console.error("Image load failed", e);
      };

      img.src = imageUrl;
    }, 50);

    return () => clearTimeout(timeout);
  }, [open, cropBox, imageUrl]);

  const handleClose = () => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');
      ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }
    onClose();
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalDialog sx={{ width: 1024 }}>
        <ModalClose />
        <DialogTitle>
          <Typography level='title-md'>
            Here is a preview of image when cropped.
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <canvas ref={canvasRef}></canvas>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default TextCropModal;
